module.exports = __webpack_public_path__ + "img/Ideen_Kontakt.7acfbe45.png";